/** A drop zone's frame, alike for files dragged onto a pool and for items dragged on the board: raised under the drag. */
export const zoneFrameClass = (over: boolean, idle: string): string =>
  `border-2 transition-[flex-grow,width,background-color,border-color,box-shadow] duration-150 ease-out motion-reduce:transition-none ${
    over ? 'border-solid border-primary bg-white shadow-lg' : idle
  }`
